<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="分配客户"
    :visible.sync="dialogVisible"
    width="920px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="5vh">
    <template slot="title">
      <span class="title">分配客户</span>
      <span v-if="isCheckCompany" class="edit" @click="isCheck = false"><i class="el-icon-edit-outline"></i>编辑</span>
    </template>
    <div class="content">
      <div class="header">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="选择分配客户" prop="companyIds">
            <el-select
              v-model="form.companyIds"
              multiple
              filterable
              clearable
              placeholder="请选择"
              style="width: 880px"
              :disabled="isCheck"
              @change="companyIdsChange">
              <el-option
                v-for="item in companyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="data">
        <BaseTable :tableData="tableData" :height="450" :isPager="false" :border="true">
          <el-radio-group slot="mblType" v-model="row.scope.mblType" slot-scope="row" :disabled="isCheck">
            <el-radio label="">全部</el-radio>
            <el-radio :label="0">海运</el-radio>
            <el-radio :label="1">空运</el-radio>
          </el-radio-group>
          <el-select slot="email" v-model="row.scope.email" slot-scope="row" placeholder="请选择" :disabled="isCheck">
            <el-option
              v-for="(item, index) in rowData?.supplierEmails"
              :key="index"
              :label="item"
              :value="item"></el-option>
          </el-select>
          <el-input
            slot="contact"
            v-model="row.scope.contact"
            slot-scope="row"
            placeholder="请输入"
            :disabled="isCheck"></el-input>
          <el-input
            slot="remark"
            v-model="row.scope.remark"
            slot-scope="row"
            placeholder="请输入"
            :disabled="isCheck"></el-input>
        </BaseTable>
      </div>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <el-button
        v-debounce-click="ok"
        :disabled="!tableData.columns.length || isCheck"
        class="ok flex_c_c">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable.vue')
import { getImporterSupplierOrCompanyList, assignCompany } from '@/api/system'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: Boolean,
    rowData: Object,
    companyOptions: Array,
    isCheckCompany: Boolean
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'companyName',
            label: '客户',
            width: 120
          },
          {
            filed: 'mblType',
            label: '提单类型',
            width: 200,
            isCustom: true
          },
          {
            filed: 'email',
            label: '邮箱',
            isCustom: true
          },
          {
            filed: 'contact',
            label: '法人',
            isCustom: true
          },
          {
            filed: 'remark',
            label: '备注',
            isCustom: true
          }
        ],
        columns: []
      },
      form: {
        companyIds: []
      },
      rules: {
        companyIds: [{ required: true, message: '请至少选择一个客户', trigger: 'change' }]
      },
      supplierEmailOptions: [],
      isCheck: false
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.reset()
        this.isCheck = this.isCheckCompany
        this.getList()
      }
    }
  },
  methods: {
    companyIdsChange() {
      if (this.isCheck) return

      const selectedIds = this.form.companyIds

      // 如果清空了，直接清空表格
      if (selectedIds.length === 0) {
        this.tableData.columns = []
        return
      }

      // 否则执行分配逻辑（无需验证）
      this.handleAllocationWithoutValidate()
    },
    reset() {
      this.form = this.$options.data().form
      this.tableData.columns = []
      this.$refs.form?.resetFields()
    },
    async getList() {
      try {
        const params = {
          importerId: this.rowData.id,
          importerAllocationType: 1
        }
        const res = await getImporterSupplierOrCompanyList(params)
        if (res.success) {
          this.form.companyIds = res.data.map((a) => a.companyId)
          this.tableData.columns = res.data.map((a) => {
            return {
              companyName: a.companyName,
              companyId: a.companyId,
              mblType: a.mblType,
              email: a.companyEmail,
              contact: a.companyContact,
              remark: a.remark
            }
          })
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    async ok() {
      try {
        const params = {
          importerId: this.rowData.id,
          companyData: this.tableData.columns
        }
        const res = await assignCompany(params)
        if (res.success) {
          this.$message.success('操作成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleAllocationWithoutValidate() {
      // 你的分配逻辑，去掉 validate
      const companyMap = new Map(this.companyOptions.map(opt => [opt.value, opt]))
      const existingCompanyIds = new Set(this.tableData.columns.map(item => item.companyId))
      const selectedCompanyIds = new Set(this.form.companyIds)

      const keptRows = this.tableData.columns.filter(row => selectedCompanyIds.has(row.companyId))
      const newCompanyIds = this.form.companyIds.filter(id => !existingCompanyIds.has(id))
      const newRows = newCompanyIds.map(id => {
        const company = companyMap.get(id)
        return {
          companyId: id,
          companyName: company?.label,
          mblType: '',
          email: '',
          contact: '',
          remark: ''
        }
      })

      this.tableData.columns = [...keptRows, ...newRows]
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-dialog__header {
  .title {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }

  .edit {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #2395f3;
    cursor: pointer;
    margin-left: 12px;

    i {
      margin-right: 3px;
    }
  }
}

.content {
  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    margin-top: -12px;

    .el-form-item {
      margin-bottom: 0;
    }

    /deep/ .el-form--label-top .el-form-item__label {
      line-height: 30px;
      padding: 0;
    }

    .btn {
      width: 88px;
      height: 40px;
      background: #2395f3;
      border-radius: 4px 4px 4px 4px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      align-self: flex-end;
    }
  }

  .data {
    /deep/ .el-table__row {
      td {
        padding: 0 !important;
      }
    }

    /deep/ .el-input {
      input {
        border: 0;
      }
    }

    /deep/ .el-radio {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }

      .el-radio__label {
        padding-left: 6px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
}

.footers {
  width: 100%;

  &>div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }

  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }

  .ok {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    background: #142e79;
    color: #ffffff;
  }
}
</style>
